<!--
  ~ Copyright (c) 2019 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<table class="table table-sm kit-table kit-scrollable-table">
  <ng-container *ngIf="columnHeaderModels.length > 0">
    <thead #headerElement>
      <tr *ngFor="let row of columnHeaderModels" [kitTags]="row.tags" [kitClick]="row" class="kit-table-row">
        <th *ngFor="let column of rowHeaderModels" [kitTags]="column.tags" [kitClick]="column" scope="col"
          class="kit-table-column">
          <div [kitTags]="getCell(row, column).tags" [kitClick]="getCell(row, column)" class="kit-table-cell">
            <ng-container [kitComponent]="getCell(row, column).content"></ng-container>
          </div>
        </th>
        <th *ngFor="let column of columnModels" [kitTags]="column.tags" [kitClick]="column" scope="col"
          class="kit-table-column">
          <div [kitTags]="getCell(row, column).tags" [kitClick]="getCell(row, column)" class="kit-table-cell">
            <ng-container [kitComponent]="getCell(row, column).content"></ng-container>
          </div>
        </th>
        <!-- <th #scrollbarOffset class="bs-kit-scrollbar-offset"></th> -->
      </tr>
    </thead>
  </ng-container>
  <tbody #bodyElement>
    <tr *ngFor="let row of rowModels" [kitTags]="row.tags" [kitClick]="row" class="kit-table-row">
      <th *ngFor="let column of rowHeaderModels" [kitTags]="column.tags" [kitClick]="column" scope="row"
        class="kit-table-column">
        <div [kitTags]="getCell(row, column).tags" [kitClick]="getCell(row, column)" class="kit-table-cell">
          <ng-container [kitComponent]="getCell(row, column).content"></ng-container>
        </div>
      </th>
      <ng-container *ngFor="let column of columnModels">
        <td *ngIf="getCell(row, column)" [kitTags]="column.tags" [kitClick]="column" [rowSpan]="getRowSpan(row, column)"
          class="kit-table-column">
          <div [kitTags]="getCell(row, column).tags" [kitClick]="getCell(row, column)" class="kit-table-cell">
            <ng-container [kitComponent]="getCell(row, column).content"></ng-container>
          </div>
        </td>
      </ng-container>
    </tr>
  </tbody>
</table>